import {
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@babackapp/ui/components/dialog";
import useTranslation from "@babackapp/translations/use-translation";
import { Dialog } from "@babackapp/ui/components/dialog";
import { Button } from "@babackapp/ui/components/button";
import { useCarriersContext } from "../../use-carriers-context";
import { useCallback } from "react";
import { ShopRoutingLocationRuleDto } from "@babackapp/private-api-client/types";

type Props = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  selectedRule: ShopRoutingLocationRuleDto;
  onCloseForm: () => void;
};

export const RemoveOneRuleDialog = ({
  isOpen,
  setIsOpen,
  selectedRule,
}: Props) => {
  const t = useTranslation();
  const { shop } = useCarriersContext();

  const { editOneCarrierRutingRule } = useCarriersContext();

  const closeForm = useCallback(() => {
    setIsOpen(false);
  }, []);

  const removeOneCarrierRule = useCallback(() => {
    const newRules = shop.routingLocationRules.filter(
      (r) => r.id !== selectedRule.id,
    );
    editOneCarrierRutingRule(newRules);
    closeForm();
  }, [shop]);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <form>
        <DialogContent className="pt-10">
          <DialogHeader>
            <DialogTitle>
              {t("settings.integrations.exports.removeExport.title")}
            </DialogTitle>
            <DialogDescription>
              {t("settings.integrations.exports.removeExport.description")}
            </DialogDescription>
          </DialogHeader>

          <div className="flex justify-between mt-5 gap-4">
            <Button
              type="button"
              variant="outline"
              onClick={closeForm}
              className="w-full"
            >
              {t("misc.cancel")}
            </Button>
            <Button
              type="submit"
              variant="default"
              className="w-full"
              onClick={removeOneCarrierRule}
            >
              {t("misc.confirm")}
            </Button>
          </div>
        </DialogContent>
      </form>
    </Dialog>
  );
};
